var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5C10 7.76142 7.76142 10 5 10C2.23858 10 1.14938e-06 7.76142 1.39079e-06 5C1.6322e-06 2.23858 2.23858 2.75149e-07 5 5.1656e-07C7.76142 7.57972e-07 10 2.23858 10 5Z",
    fill: "#F86868"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99995 7.67856C4.70408 7.67856 4.46423 7.43871 4.46423 7.14284L4.46423 4.82142C4.46423 4.52555 4.70408 4.2857 4.99995 4.2857C5.29581 4.2857 5.53566 4.52555 5.53566 4.82142L5.53566 7.14284C5.53566 7.43871 5.29581 7.67856 4.99995 7.67856Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28566 3.03571C4.28566 2.64123 4.60546 2.32143 4.99995 2.32143C5.39444 2.32143 5.71423 2.64123 5.71423 3.03571C5.71423 3.4302 5.39444 3.75 4.99995 3.75C4.60546 3.75 4.28566 3.4302 4.28566 3.03571Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadError);
export default __webpack_public_path__ + "static/media/download_error.2d4c96acf78804edd863fea311f6c525.svg";
export { ForwardRef as ReactComponent };